import React from 'react';
import { Dropdown } from '@xingternal/winery-ui/lib/Dropdown';
import { ButtonWithDropdown } from '@xingternal/winery-ui/lib/ButtonWithDropdown';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const DropDownTrigger = styled(ButtonWithDropdown.Trigger)`
  align-self: center;
  border: 1px solid ${themeGet('colors.borderMedium')};
  border-radius: ${({ hasOnlyDropdown }) =>
    hasOnlyDropdown && themeGet('radii.1')};
  border-left: ${({ hasOnlyDropdown }) => !hasOnlyDropdown && 'none'};

  &[type='button'][type='button'] {
    background-color: ${themeGet('colors.white')};
  }
`;

const DropdownMenu = ({
  closeOnClick,
  testid,
  icon,
  listWidth,
  items,
  hasOnlyDropdown,
}) => {
  return (
    <>
      <ButtonWithDropdown.Dropdown closeOnClick={closeOnClick}>
        <DropDownTrigger
          data-testid={testid}
          icon={icon}
          hasOnlyDropdown={hasOnlyDropdown}
        />
        <Dropdown.Menu width={listWidth}>
          {items.map(
            ({ action, item, disabled = false, datatestid }, index) => (
              <Dropdown.MenuItem
                disabled={disabled}
                key={`list-item-${index}`}
                onClick={action}
                data-testid={datatestid}
              >
                {item}
              </Dropdown.MenuItem>
            ),
          )}
        </Dropdown.Menu>
      </ButtonWithDropdown.Dropdown>
    </>
  );
};

export { DropdownMenu };
